const url = new URL(window.location.href);
const searchParams = url.searchParams;



export default {
    hasParam(key, value = null) {
      if (value !== null) {
        return searchParams.get(key) === value;
      }
      return searchParams.has(key);
    },
    getParam(key) {
      return searchParams.get(key);
    },
    getAllParam(key) {
      return searchParams.getAll(key)
    },
    deleteParam(key) {
        if (!this.hasParam(key)) {
            return this;
        }

        searchParams.delete(key)
        window.history.replaceState({}, document.title, url.toString());

        return this;
    },
    addParam(key, value) {
        if (this.hasParam(key)) {
            searchParams.set(key, value)
        } else {
            searchParams.append(key, value)
        }

        window.history.replaceState({}, document.title, url.toString());

        return this
    },
    reload() {
        window.location.reload()
    },
    normalizeImgUrl(imgUrl) {
      if (imgUrl.startsWith('/share?file=')) {
        return imgUrl;
      }

      if (imgUrl.includes('share?file=')) {
        const pathStart = imgUrl.indexOf('/share?file=');
        
        return imgUrl.substring(pathStart);
      }

      return '/share?file=' + imgUrl;
    }
}

